"use strict";
exports.__esModule = true;
exports.defaultClusterer = exports.getDefaultClusterConfig = void 0;
var GRID_SIZE = 80;
var getDefaultClusterConfig = function (viewport) {
    return {
        gridSize: viewport.zoom > 13 && viewport.zoom < 17 ? 50 : GRID_SIZE,
        showAll: viewport.zoom < 15
    };
};
exports.getDefaultClusterConfig = getDefaultClusterConfig;
var defaultClusterer = function (gridInfoValue, viewport) {
    var gridNodes = gridInfoValue.items;
    var isCluster = gridNodes.length > 1;
    var _a = gridInfoValue.position, lat = _a.lat, lng = _a.lng;
    var type = gridNodes[0].type;
    var count = gridNodes.reduce(function (acc, it) { return acc + Number(it.count); }, 0);
    var value = isCluster ? gridInfoValue.items : gridNodes[0].value;
    var title = '';
    var popupActive = gridNodes.findIndex(function (it) { return it.popupActive; }) >= 0;
    var pin = { title: title, value: value, lat: lat, lng: lng, type: type, count: count, popupActive: popupActive, isCluster: isCluster };
    return pin;
};
exports.defaultClusterer = defaultClusterer;
